import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'

function drawCheckbox(doc, cell)
{
	const { x, y, width, height } = cell
	const size = 5.5
	const cx = x + width / 2 - size / 2
	const cy = y + height / 2 - size / 2
	doc.setLineCap('butt')
	doc.setDrawColor(60, 60, 60)
	doc.setLineWidth(0.4)
	doc.rect(cx, cy, size, size)
}

// Coche verte 100 % vectorielle : aucun bitmap à décoder (l'emoji canvas puis
// le PNG base64 ne s'affichaient pas sur certains postes Windows).
function drawCheck(doc, cell)
{
	const { x, y, width, height } = cell
	const size = 5.5
	const cx = x + width / 2 - size / 2
	const cy = y + height / 2 - size / 2
	doc.setLineCap('round')
	doc.setLineJoin('round')
	doc.setDrawColor(22, 163, 74)
	doc.setLineWidth(0.9)
	doc.line(cx + size * 0.15, cy + size * 0.55, cx + size * 0.4, cy + size * 0.8)
	doc.line(cx + size * 0.4, cy + size * 0.8, cx + size * 0.85, cy + size * 0.2)
}

export function generateArrivalsPDF(stays, dateLabel, formatTime, qr_set, location_ready_map, onsite_map, jacuzzi_map, show_jacuzzi, kit_double_map, kit_simple_map, baby_beds_map, show_kits, arrival_dashboard_map, show_date_col, kit_towels_map, baby_chairs_map)
{
	const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' })

	doc.setFont('helvetica', 'bold')
	doc.setFontSize(14)
	doc.text(`Arrivées — ${dateLabel}`, doc.internal.pageSize.getWidth() / 2, 16, { align: 'center' })

	doc.setFont('helvetica', 'normal')
	doc.setFontSize(10)
	doc.setTextColor(120, 120, 120)
	doc.text(`${stays.length} séjour${stays.length > 1 ? 's' : ''}`, doc.internal.pageSize.getWidth() / 2, 22, { align: 'center' })
	doc.setTextColor(0, 0, 0)

	const adm = arrival_dashboard_map || {}

	// column index map (shifted by 1 when date column is shown)
	const col_offset = show_date_col ? 1 : 0
	const name_col_offset = show_kits ? 0 : 1
	const mh_col = 4 + col_offset + name_col_offset
	const onsite_col = 5 + col_offset + name_col_offset
	const jac_col = show_jacuzzi ? 6 + col_offset + name_col_offset : null
	const qr_col = (show_jacuzzi ? 7 : 6) + col_offset + name_col_offset

	const head_row = []
	if (show_date_col)
		head_row.push('Date')
	head_row.push('H. arrivée', 'N° emp.', 'Catégorie')
	if (!show_kits)
		head_row.push('Nom du client')
	head_row.push('Particip.s', 'Mh prép.', 'Arrivé')
	if (show_jacuzzi)
		head_row.push('Jacuzzi')
	head_row.push('QR')
	if (show_kits)
		head_row.push('Lits bébé', 'Kits double', 'Kits simple', 'Kit serviettes', 'Chaise haute')

	const rows = stays.map(stay => {
		const pc = stay.precheckin
		const client = stay.client || {}
		const lastname = (pc && pc.lastname) || client.lastname || ''
		const firstname = (pc && pc.firstname) || client.firstname || ''
		const fullname = [lastname.toUpperCase(), firstname].filter(Boolean).join(' ')
		const has_qr = stay.location && stay.arrival_time
			? qr_set.has(stay.location + ':' + new Date(stay.arrival_time * 1000).toLocaleDateString('fr-CA', { timeZone: 'Europe/Paris' }))
			: false
		const eff_arrival = (pc && pc.estimate_arrival) || (adm[stay.stay_number] != null ? adm[stay.stay_number] : null)
		const row = []
		if (show_date_col)
		{
			const day_key = stay.arrival_time
				? new Date(stay.arrival_time * 1000).toLocaleDateString('fr-CA', { timeZone: 'Europe/Paris' })
				: ''
			row.push(day_key ? `${day_key.substring(8, 10)}/${day_key.substring(5, 7)}` : '')
		}
		const participant_count = (pc && pc.participants && pc.participants.length > 0) ? pc.participants.length : ''
		row.push(formatTime(eff_arrival), stay.location || '', stay.location_category || '')
		if (!show_kits)
			row.push(fullname)
		row.push(
			participant_count,
			!!location_ready_map[stay.stay_number],
			!!(onsite_map && onsite_map[stay.stay_number])
		)
		if (show_jacuzzi)
			row.push(!!jacuzzi_map[stay.stay_number])
		row.push(has_qr)
		if (show_kits)
			row.push(
				baby_beds_map[stay.stay_number] || '',
				kit_double_map[stay.stay_number] || '',
				kit_simple_map[stay.stay_number] || '',
				(kit_towels_map && kit_towels_map[stay.stay_number]) || '',
				(baby_chairs_map && baby_chairs_map[stay.stay_number]) || ''
			)
		return row
	})

	const col_styles = {}
	if (show_date_col)
		col_styles[0] = { cellWidth: 16, halign: 'center' }
	col_styles[0 + col_offset] = { cellWidth: 18, halign: 'center' }
	col_styles[1 + col_offset] = { cellWidth: 18, halign: 'center' }
	col_styles[2 + col_offset] = { cellWidth: 32 }
	if (!show_kits)
		col_styles[3 + col_offset] = { cellWidth: 'auto' }
	col_styles[3 + col_offset + name_col_offset] = { cellWidth: 20, halign: 'center' }
	col_styles[4 + col_offset + name_col_offset] = { cellWidth: 22, halign: 'center' }
	col_styles[5 + col_offset + name_col_offset] = { cellWidth: 18, halign: 'center' }
	if (show_jacuzzi)
		col_styles[6 + col_offset + name_col_offset] = { cellWidth: 18, halign: 'center' }
	col_styles[qr_col] = { cellWidth: 15, halign: 'center' }
	if (show_kits)
	{
		col_styles[qr_col + 1] = { cellWidth: 16, halign: 'center' }
		col_styles[qr_col + 2] = { cellWidth: 16, halign: 'center' }
		col_styles[qr_col + 3] = { cellWidth: 16, halign: 'center' }
		col_styles[qr_col + 4] = { cellWidth: 16, halign: 'center' }
		col_styles[qr_col + 5] = { cellWidth: 16, halign: 'center' }
	}

	autoTable(doc, {
		startY: 27,
		head: [head_row],
		body: rows,
		styles: { fontSize: 9, cellPadding: 3 },
		headStyles: { fillColor: [79, 70, 229], textColor: 255, fontStyle: 'bold', halign: 'center' },
		alternateRowStyles: { fillColor: [243, 244, 246] },
		columnStyles: col_styles,
		didParseCell: (data) => {
			if (data.section !== 'body')
				return
			const col = data.column.index
			if (col === mh_col || col === onsite_col || col === jac_col || col === qr_col)
				data.cell.text = ['']
		},
		didDrawCell: (data) => {
			if (data.section !== 'body')
				return
			const col = data.column.index
			if (col === mh_col)
			{
				if (data.cell.raw === true)
					drawCheck(doc, data.cell)
				else
					drawCheckbox(doc, data.cell)
			}
			else if (col === onsite_col)
			{
				if (data.cell.raw === true)
					drawCheck(doc, data.cell)
				else
					drawCheckbox(doc, data.cell)
			}
			else if (col === jac_col)
			{
				if (data.cell.raw === true)
					drawCheck(doc, data.cell)
				else
					drawCheckbox(doc, data.cell)
			}
			else if (col === qr_col && data.cell.raw === true)
			{
				drawCheck(doc, data.cell)
			}
		}
	})

	const pageCount = doc.internal.getNumberOfPages()
	const pageWidth = doc.internal.pageSize.getWidth()
	const pageHeight = doc.internal.pageSize.getHeight()
	const fileLabel = dateLabel.replace(/[^0-9a-zA-Z_-]/g, '_')
	for (let i = 1; i <= pageCount; i++)
	{
		doc.setPage(i)
		doc.setFontSize(8)
		doc.setTextColor(150, 150, 150)
		doc.text(
			`arrivees_${fileLabel}.pdf — page ${i}/${pageCount}`,
			pageWidth / 2,
			pageHeight - 5,
			{ align: 'center' }
		)
	}
	doc.setTextColor(0, 0, 0)

	doc.save(`arrivees_${fileLabel}.pdf`)
}
